import React from 'react';
import './PrivacyPolicyPage.css';

function PrivacyPolicyPageItLite() {
    return (
        <div className="privacy-policy-container">
<h1>Politica sulla Privacy di Tasbih Dhikr Lite</h1>
      <p>Ultimo aggiornamento: 31 gennaio 2024</p>

      <h2>Introduzione</h2>
      <p>Benvenuti nell'app Tasbih Dhikr Lite. Questa politica sulla privacy intende informarvi su come gestiamo i vostri dati quando utilizzate la nostra applicazione. L'unica raccolta di dati in questa app è effettuata da AdMob, un servizio di pubblicità di Google, e non raccogliamo attivamente dati personali.</p>

      <h2>1. Raccolta e Utilizzo dei Vostri Dati Personali</h2>
      <h3>a. Tipi di Dati Raccolti</h3>
      <h4>i. Utilizzo dei Dati tramite AdMob</h4>
      <p>La nostra app utilizza AdMob per mostrare pubblicità. AdMob può raccogliere dati come il vostro indirizzo IP, l'identificatore del dispositivo e informazioni sull'utilizzo dell'app. Questi dettagli sono utilizzati per fornire e migliorare l'esperienza pubblicitaria.</p>

      <h3>b. Uso dei Dati</h3>
      <p>I dati raccolti da AdMob sono utilizzati per:</p>
      <ul>
        <li>Fornire e personalizzare le pubblicità all'interno dell'app.</li>
        <li>Analisare l'efficacia delle pubblicità visualizzate.</li>
      </ul>

      <h3>c. Controllo dell'Utente</h3>
      <p>Potete controllare l'uso dei vostri dati per la pubblicità personalizzata tramite le impostazioni del vostro dispositivo.</p>

      <h2>2. Trasferimento dei Dati</h2>
      <p>I vostri dati possono essere trasferiti e mantenuti su computer situati al di fuori del vostro stato, provincia o paese dove le leggi sulla protezione dei dati possono differire.</p>

      <h2>3. Divulgazione dei Vostri Dati Personali</h2>
      <p>I dati raccolti da AdMob possono essere condivisi in conformità con la politica sulla privacy di Google e i requisiti legali.</p>

      <h2>4. Sicurezza dei Vostri Dati Personali</h2>
      <p>La sicurezza dei vostri dati è importante per noi. Tuttavia, nessun metodo di trasmissione su Internet o di archiviazione elettronica è sicuro al 100%.</p>

      <h2>5. Link ad Altri Siti</h2>
      <p>Il nostro servizio può contenere link ad altri siti. Se fate clic su un link di terze parti, sarete indirizzati al sito di quella terza parte.</p>

      <h2>6. Modifiche a Questa Politica sulla Privacy</h2>
      <p>Potremmo aggiornare la nostra politica sulla privacy di tanto in tanto. Vi informeremo di eventuali cambiamenti pubblicando la nuova politica sulla privacy su questa pagina.</p>

      <h2>7. Contattateci</h2>
      <p>Se avete domande su questa politica sulla privacy, contattateci.</p>

      <h2>Link Utili</h2>
      <p><a href="https://policies.google.com/privacy">Politica sulla Privacy di Google</a></p>
    </div>
     
    );
}

export default PrivacyPolicyPageItLite;
